'use strict';

var MIME_TYPES = require('../mime-types');

/**
 * Search API
 *
 * @namespace
 * @name api.search
 */
module.exports = function search(options, utils) {
    return {

        /**
         * Search the catalog
         *
         * @method
         * @memberof api.search
         * @param {object} params - A search catalog
         * @returns {promise}
         */
        catalog: utils.requestFun({
            authFlow: options.authFlow,
            baseUrl: options.baseUrl,
            method: 'GET',
            resource: '/search/catalog',
            headers: {
              'Accept': MIME_TYPES.DOCUMENT
            },
            responseFilter: utils.paginationFilter
        }),

        /**
         * Search for profiles
         *
         * @method
         * @memberof api.search
         * @param {object} params
         * @returns {promise}
         */
        profiles: utils.requestFun({
            authFlow: options.authFlow,
            baseUrl: options.baseUrl,
            method: 'GET',
            resource: '/search/v2/profiles',
            headers: {
              'Accept': MIME_TYPES.PROFILES
            }
        }),

        /**
         * Search for groups
         *
         * @method
         * @memberof api.search
         * @param {object} params
         * @returns {promise}
         */
        groups: utils.requestFun({
            authFlow: options.authFlow,
            baseUrl: options.baseUrl,
            method: 'GET',
            resource: '/search/v2/groups',
            headers: {
              'Accept': MIME_TYPES.GROUP_SEARCH_RESULTS
            }
        })
    };
};



//////////////////
// WEBPACK FOOTER
// ./lib/api/search.js
// module id = 42
// module chunks = 0